import { Suspense, lazy, ElementType } from "react";
// components
import LoadingScreen from "../components/loading-screen";

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) => (
  <Suspense fallback={""}>
    <Component {...props} />
  </Suspense>
);

// ----------------------------------------------------------------------

export const LoginPage = Loadable(
  lazy(() => import("../pages/auth/login/LoginPage")),
);
export const LoginVerifyPage = Loadable(
  lazy(() => import("../pages/auth/login/LoginVerifyPage")),
);
export const ResetPassword = Loadable(
  lazy(() => import("../pages/auth/login/ResetPassword")),
);
export const SetNewPassword = Loadable(
  lazy(() => import("../pages/auth/login/SetNewPassword")),
);

// dashboard
export const Dashboard = Loadable(
  lazy(() => import("../pages/dashboard/index")),
);

//business management

export const AllBusinesses = Loadable(
  lazy(() => import("../pages/BusinessManagement/allBusinesses/AllBusinesses")),
);
export const BusinessView = Loadable(
  lazy(() => import("../pages/BusinessManagement/allBusinesses/BusinessView")),
);
export const BusinessConnections = Loadable(
  lazy(() => import("../pages/BusinessManagement/businessConnections/index")),
);
export const OnboardingRequests = Loadable(
  lazy(
    () => import("../pages/BusinessManagement/onboarding/OnboardingRequests"),
  ),
);
export const OnboardingRequestView = Loadable(
  lazy(
    () =>
      import("../pages/BusinessManagement/onboarding/OnboardingRequestView"),
  ),
);

//invoices
export const Invoices = Loadable(lazy(() => import("../pages/invoices/index")));

//accounting
export const Accounting = Loadable(
  lazy(() => import("../pages/accounting/index")),
);

//billing
export const Billing = Loadable(lazy(() => import("../pages/billing/index")));

//fee
export const AssuredPayFee = Loadable(lazy(() => import("../pages/fee/index")));

//activity
export const Activity = Loadable(lazy(() => import("../pages/activity/index")));

//controls
export const AdminControl = Loadable(
  lazy(() => import("../pages/controls/index")),
);
//bank Logs
export const BankLogs = Loadable(
  lazy(() => import("../pages/bankLogs/BankLogs")),
);

//Affiliate
export const AffiliateAnalytics = Loadable(
  lazy(() => import("../pages/affiliate/Analytics")),
);
export const Affiliate = Loadable(
  lazy(() => import("../pages/affiliate/index")),
);
export const Tier = Loadable(lazy(() => import("../pages/affiliate/Tier")));
export const Settlement = Loadable(
  lazy(() => import("../pages/affiliate/Settlement")),
);
export const AffiliatesInvited = Loadable(
  lazy(() => import("../pages/affiliate/AffiliatesInvited")),
);

// Sales Components
export const SalesDashboard = Loadable(
  lazy(() => import("../pages/Sales/dashboard")),
);

export const SalesUsersList = Loadable(
  lazy(() => import("../pages/Sales/users/SalesUsersList")),
);

export const AddSalesUser = Loadable(
  lazy(() => import("../pages/Sales/users/AddSalesUser")),
);

export const EditSalesUser = Loadable(
  lazy(() => import("../pages/Sales/users/EditSalesUser")),
);

export const ViewSalesUser = Loadable(
  lazy(() => import("../pages/Sales/users/ViewSalesUser")),
);

export const IncentiveRules = Loadable(
  lazy(() => import("../pages/Sales/incentive-rules/IncentiveRules")),
);

export const AddIncentivePlan = Loadable(
  lazy(() => import("../pages/Sales/incentive-rules/AddIncentivePlan")),
);
export const EditIncentivePlan = Loadable(
  lazy(() => import("../pages/Sales/incentive-rules/EditIncentivePlan")),
);

export const SalesSettlement = Loadable(
  lazy(() => import("../pages/Sales/Settlement/Settlement")),
);

// leads
export const Leads = Loadable(lazy(() => import("../pages/leads/index")));

//chats
export const Chat = Loadable(lazy(() => import("../pages/Chat")));
export const TicketManagement = Loadable(
  lazy(() => import("../pages/ticket-management/index")),
);
export const TicketDetail = Loadable(
  lazy(() => import("../pages/ticket-management/TicketDetail")),
);

// feedback
export const Feedback = Loadable(lazy(() => import("../pages/support")));

export const Page404 = Loadable(lazy(() => import("../pages/Page404")));
